import * as types from '../actions/actionTypes';
import {SQFT_MEASURE_UNIT, SQFT_VIEW_MODE} from "../bvcomponents/sqft/constants";

const initialState = {
  isSquareFootageEnabled: false,
  SQFTGroup: null, // used to display different sqft types ( like cabinets, area, etc..)
  SQFTViewMode: SQFT_VIEW_MODE.twoDMode,  // used to display 2d - 3d view
  sqftLoaded: false,
  sqftUpdateType: null,
  squareFeet: 0,
  changeLayoutPopupOpened: false,
  layoutToApply: "",
  sqftFromFeature: null, // feature from SQFT was opened
  applyLayoutOnSqft: false, // this is needed to remember to change layout on popup ok click
  setNewLayoutOnSqft: false, // this is needed for change layout popup - after ok click - it send a postMessage to SQFT
  sqftFeaturesPopup: {
    enabled: true,
    opened: false,
    visited: false,
    sqftPassedData: null, // object passed from calculator
    previouslyAddedSqftFeatures: [] // remember previous selections to parse properly data
  },
  measureUnit: SQFT_MEASURE_UNIT.imperial,
  updateCalculations: false, // update sqft calculations
  // todo move this to new reducer
  abortRequestController: null,
  selectedCountertop: null,
  selectedWall: null,
  cabinetsGlb: null,
  cabinetsARBlobUrl: null,
  apiErrorMessage: null,
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.ENABLE_SQUARE_FOOTAGE:
    case types.SET_SQUARE_FOOTAGE_GROUP:
    case types.SET_SQFT_VIEW_MODE:
    case types.LOAD_SQFT:
    case types.UPDATE_SQFT:
    case types.UPDATE_SQFT_CALCULATIONS:
    case types.SET_SQFT_SQUARE_FEET:
    case types.SET_NEW_LAYOUT_ON_SQFT:
    case types.SET_SQFT_MEASURE_UNIT:
    case types.SQT_SQFT_FROM_FEATURE:
    case types.SET_CABINETS_GLB:
    case types.SET_CABINETS_AR_BLOB_URL:
    case types.SET_API_ERROR_MESSAGE:
    case types.SET_SELECTED_COUNTERTOP:
    case types.SET_SELECTED_WALL:
    case types.SET_ABORT_CONTROLLER:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.TOGGLE_CHANGE_LAYOUT_POPUP:
      return Object.assign({}, state, {
        changeLayoutPopupOpened: action.payload.changeLayoutPopupOpened,
        layoutToApply: action.payload.layoutToApply || state.layoutToApply,
        applyLayoutOnSqft: action.payload.applyLayoutOnSqft,
      });
    case types.CHANGE_SQFT_FEATURES_POPUP:
      state = {...state, sqftFeaturesPopup: Object.assign({}, state.sqftFeaturesPopup, action.payload.sqftFeaturesPopup)};
      break;
  }

  return state;

}
